import React from 'react';
// import { Link } from 'react-router-dom';
//import FontAwesome from 'react-fontawesome';
import * as CardComponents from '../../Common/CardComponents';

import cx from '../../../styles';

const CardTemplateComponent = (ChildTemplate) => (props) => {

    const { TopicLink, AuthorLink, LastSeen, ActionLink, ResponseBar } = CardComponents;
    
    const { topic, author, lastSeen, actions, responseBar, inFeed, ifTapPoll, appReducer, siteUrl, cardName, match, status, likeErrorMessage, botIndex = false, url, contentHub, id } = props;
    
    return (
        <div className={cx("card-template")}>
            {
                !ifTapPoll &&
                <div className={cx("card-template-top")}>
                    <aside className={cx("left")}>
                        <TopicLink 
                            id={topic.id} 
                            slug={topic.slug} 
                            url={topic.url} 
                            name={topic.name} 
                            imageUrl={topic.image} 
                            background={topic.background_2}
                            appReducer = {appReducer}
                            cardName = {cardName}
                            match= {match}
                        />
                    </aside>    
                    <aside className={cx("right")}>
                        <LastSeen lastSeen={lastSeen} botIndex={botIndex} url={inFeed ? props.siteUrl+props.viewUrl : ''} cardName = {cardName} match= {match}/>
                        {
                            !contentHub && 
                            <ActionLink actions={actions} cardName = {cardName} match= {match} id={id} topic={topic}/>
                        }
                    </aside>
                </div>
            }

            <section className={"post-section"}>
                {/*<div className={cx("post-section-header")}>
                    <AuthorLink id={author.id} slug={siteUrl + author.slug} url={author.url} fullName={author.fullname} tagLine={author.tagline} imageUrl={author.image} />

                    <div className={cx("right")}>
                        <LastSeen lastSeen={lastSeen} />
                        <ActionLink actions={actions} />
                    </div>
                </div>*/}

                <div className={cx("post-section-body")}>
                    
                    <div className={cx("child-card-components")}>
                        <ChildTemplate {...props} />
                    </div>

                    {
                        !inFeed && !ifTapPoll &&
                        <AuthorLink id={author.id} slug={author.slug ? siteUrl + author.slug : ''} url={author.url} fullName={author.fullname} tagLine={author.tagline} imageUrl={author.image} cardName = {cardName} match= {match}/>
                    }
                    
                    <ResponseBar botIndex={botIndex} likes={responseBar.likes} replyCount={responseBar.replyCount} ifTapPoll={ifTapPoll} url={`${contentHub ? url : props.siteUrl + props.viewUr}`}
                        onLikeClick={responseBar.onLikeClick} onReplyClick={responseBar.onReplyClick} onShareClick={responseBar.onShareClick} inFeed={inFeed} cardName = {cardName} match= {match} status={status} likeErrorMessage={likeErrorMessage}/>
                </div>
            </section>
        </div>
    )
}

export default CardTemplateComponent;
